/*globals $:false*/

import DomainM from './model/recordm.model.entity.domain.js';
import InstanceActions from './actions/recordm.actions.instance.js';
import SimpleSearchM from './model/recordm.model.simplesearch.js';
import SimpleSearchP from './presenter/recordm.presenter.simplesearch.js';
import UnifiedSearchResultP from './presenter/recordm.presenter.searchresult.unified.js';

import { sprintf } from 'sprintf-js';

import tmpl_unified_search from './templates/search-unified.dot';

import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

var Domain = function(core, baseUri) {

    var _$mainContainer,
        _running = false,
        _searchP,
        _unifiedSearchResultP;

    var _instanceActions;

    var _searchM,
        _searchQuery;

    var _domainM;

    var _onDomainUpdated = function(e, data) {
        _domainM = core.getModels(DomainM.entityKey + ":" + data.id);

        // This update solves the syncronism of the list of definitions that belongs
        // to the domain. This sync will only be visible when we are in the unified search
        // and haven't yet make a search.
        _searchP.updateDomainM(_domainM);

        // update the breadcrumbs if the domain has changed name.
        core.publish("modules:stack-description-updated");
    };

    var _loadDomain = function(domainId, domainLoadLatch) {
        DomainM.get(core, domainId, {
            forceReload: true,

            success: function(domainM) {
                _domainM = domainM;

                core.subscribe(domainM.update_event_name, _onDomainUpdated);
                core.subscribe(domainM.definition_added_event_name, _onDomainUpdated);
                core.subscribe(domainM.definition_removed_event_name, _onDomainUpdated);

                core.publish("modules:stack-description-updated");
                domainLoadLatch.countDown("domain:loaded:" + domainM.data.id);
            },

            error: function(status) {
                if (status === 404) {
                    ui.notification.showCustom(
                        'error',
                        sprintf(core.translateString("recordm.domains", "domains.msg.error-title"), domainId),
                        core.translateString("recordm.domains", "domains.msg.not-found")
                    );
                }
            }
        });
    };

    var _init = function(domainId, searchQuery) {
        _running = true;

        _searchQuery = searchQuery;

        // Creating a latch because the code becomes more
        // simple to read. This will happen after the domain has been loaded
        // successfully.
        var domainLoadLatch = new utils.CountdownLatch(1, function() {

            _$mainContainer = $(tmpl_unified_search({domainM: _domainM}));
            core.translate("recordm.search", _$mainContainer);
            if(_running) _$mainContainer.appendTo('#'+core.getAppInstanceId());

            // Create a SimpleSearchM to add to the presenter
            _searchM = new SimpleSearchM(core, "recordm/domains/search/" + _domainM.data.id);

            // Create a SimpleSearchPresenter and initialize it
            _searchP = new SimpleSearchP(core,
                baseUri,
                _domainM,
                _searchM,
                $(".js-search-container", _$mainContainer),
                {"advance-search": false},
                {
                    getCurrentVisualization: function() {
                        return undefined;
                    },
                    updateUri: function(newState) {
                        core.navigateTo(_domainM.buildUriForQuery(newState.searchText ?? _searchM.getQuery()));
                    }
                }
            );

            _instanceActions = new InstanceActions(core);

            // Initialize the unified search results presenter
            _unifiedSearchResultP = new UnifiedSearchResultP(
                core,
                baseUri,
                _domainM,
                _searchM,
                _instanceActions,
                _$mainContainer
            );

            // Start the search presenter with the query
            // that was received as an argument. This should be
            // the same query that is present in the url
            _searchP.init(searchQuery);
            _searchP.prepareView();

            _unifiedSearchResultP.init();
        });

        _loadDomain(domainId, domainLoadLatch);

    };

    var _pause = function() {
        _running = false;
        if (_domainM) {
            _searchP.pause();
            _unifiedSearchResultP.pause();

            _$mainContainer.detach();
        }
    };

    var _resume = function() {
        _running = true;
        if (_domainM) {

            _$mainContainer.appendTo('#'+core.getAppInstanceId());

            _searchP.resume();
            _unifiedSearchResultP.resume();
        }
    };

    var _destroy = function() {
        _running = false;
        if (_domainM) {
            _$mainContainer.remove();

            _searchP.destroy();
            _unifiedSearchResultP.destroy();

            core.unsubscribe(_domainM.update_event_name, _onDomainUpdated);
            core.unsubscribe(_domainM.definition_added_event_name, _onDomainUpdated);
            core.unsubscribe(_domainM.definition_removed_event_name, _onDomainUpdated);

            _domainM.release();
        }
    };

    return {
        init: _init,
        pause: _pause,
        resume: _resume,
        destroy: _destroy,

        getDescription: function() {
            if (_domainM) {
                return {
                    domain: {
                        id:_domainM.data.id,
                        name: _domainM.data.name
                    }
                }
            }else {
                if (_domainM) {
                    return {
                        domain: {}
                    }
                }
            }
        }
    };
};

export default Domain;
